<template>
  <g clip-path="url(#clip0_9931_22675)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 6.78872C0 3.03941 2.98477 0 6.66667 0H9.33333C13.0152 0 16 3.03941 16 6.78872C16 10.538 13.0152 13.5774 9.33333 13.5774H6.66667C6.45422 13.5774 6.24409 13.5673 6.03672 13.5475L3.09992 15.94C2.92532 16.0822 2.66667 15.9556 2.66667 15.7279V12.2202C1.0474 10.9817 0 9.00974 0 6.78872ZM10.6667 6.69108C10.6667 7.44095 11.2637 8.04883 12.0001 8.04883C12.7364 8.04883 13.3334 7.44095 13.3334 6.69108C13.3334 5.94122 12.7364 5.33333 12.0001 5.33333C11.2637 5.33333 10.6667 5.94122 10.6667 6.69108ZM6.66684 6.69115C6.66684 7.44101 7.2638 8.04889 8.00018 8.04889C8.73656 8.04889 9.33352 7.44101 9.33352 6.69115C9.33352 5.94128 8.73656 5.3334 8.00018 5.3334C7.2638 5.3334 6.66684 5.94128 6.66684 6.69115ZM2.66667 6.69115C2.66667 7.44101 3.26362 8.04889 4 8.04889C4.73638 8.04889 5.33334 7.44101 5.33334 6.69115C5.33334 5.94128 4.73638 5.3334 4 5.3334C3.26362 5.3334 2.66667 5.94128 2.66667 6.69115Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_9931_22675">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</template>
